import React from "react";
import { Link } from "react-router-dom";
import { useState,useEffect } from "react";
import { useTranslation } from "react-i18next";
import useScrollAnimation from "../../hooks/UseScrollAnimation";
import axios from "axios";
export default function Suppliers() {
    const { t } = useTranslation();

    const [data,setData] = useState([]);

    useEffect(() =>{
        const fetchData = async () => {
            try{
                const respons = await axios.get("https://laravel-api.alnujoud-jo.com/api/logos");
                setData(respons.data.data);
            }
            catch(error){
                console.error("Error When Fetch Data : ",error)
            }
        }
        fetchData();
    },[])

    useScrollAnimation();
    const showData = data.map((el) =>
        <Link to={`/suppliersProduct/${el.id}`} key={el.id} className=" w-[200px] h-[200px] bg-[rgba(100,170,178,0.2)] rounded-[8px] p-2.5">
            <img className="w-[100%] h-[100%] object-contain" src={`${el.img_logo}`} alt="" />
        </Link>
    )
    return (
        <>
            <section className="landingpages">
                <div className="container h-full flex flex-col items-center justify-center text-center">
                    <div className="btmAni1256 text-[#017E89] font-bold text-[35px] capitalize">{t("Our Suppliers")}</div>
                    <div className="btmAni2000 flex items-center gap-[5px] fonbold">
                        <Link to={"/"}>{t("Home")}</Link>
                        -
                        <span className="text-[#017E89] capitalize">{t("Our Suppliers")}</span>
                    </div>
                </div>
            </section>
            <section className="relative py-[40px]">
                <div className="container flex flex-col gap-[50px]">
                    <div className="btmAni25002 flex items-baseline gap-[7px]">
                        <img className="w-[35px] h-auto" src={require("../../assets/icons/lineTitle.svg").default} alt="" />
                        <div className="font-bold capitalize text-[25px] text-[#017e89]">{t("Our Suppliers")}</div>
                    </div>
                    <div className="flex items-center gap-[10px] flex-wrap justify-center">
                        {showData}
                    </div>
                </div>
            </section>
        </>
    );
}